/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-11-17 17:53:30
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-18 14:51:30
 */
import req from "@/utils/request";
export const findListPage = (params) => req.post("/interact-service/m/isQuestionCommon/findQuestionCommonListPage", params);
export const updateDisplayStatus = (params) => req.post("/interact-service/m/isQuestionCommon/updateCommonWhetherEnable", params);
export const collectDelete = (params) => req.post("/interact-service/m/isQuestionCommon/deleteQuestionCommon", params);
export const updateHotSort = (params) => req.post("/interact-service/m/isQuestionCommon/updateSort", params);
export const findAnswerListPage = (params) => req.post("/interact-service/m/isQuestionAnswer/isQuestionCommon/findAnswerListPage", params);
export const findList = (params) => req.post("/interact-service/m/isQuestionClassification/findList", params);
export const saveQuestionCommon = (params) => req.post("/interact-service/m/isQuestionCommon/saveQuestionCommon", params);